import script from "./graduation-materials.vue?vue&type=script&setup=true&lang=js"
export * from "./graduation-materials.vue?vue&type=script&setup=true&lang=js"

import "./graduation-materials.vue?vue&type=style&index=0&id=9df6f136&lang=less&scoped=true"

import exportComponent from "/usr/local/jenkins/workspace/pc-web_pc-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9df6f136"]])

export default __exports__